import { reactive } from 'vue';
import { LinkType, NavigationItemModel } from '@/types/B2CcontentServerContract';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';

export type SelectedNavigationItemEntries = {
    [depthIndex: number]: NavigationItemModel | undefined;
}

const selectedItems = reactive<Map<number, NavigationItemModel>>(new Map());

export default function useNavigationRenderer() {
    const deselectSubItems = (depthIndex: number): void => {
        selectedItems.forEach((value, key) => {
            if (key > depthIndex) {
                selectedItems.delete(key);
            }
        });
    };

    const toggleSelectedItem = (item: NavigationItemModel, depthIndex: number): void => {
        const selectedItem = selectedItems.get(depthIndex);
        if (item === selectedItem) {
            if (depthIndex === 0) {
                navigationTrackingService.menuItem(null);
            }
            selectedItems.delete(depthIndex);
            if (depthIndex !== 0) {
                navigationTrackingService.menuItem(item);
            }
        } else {
            selectedItems.set(depthIndex, item);
            navigationTrackingService.menuItem(item);
        }
        handleDeselectionOfItems(item, depthIndex);
    };

    const handleDeselectionOfItems = (item: NavigationItemModel, depthIndex: number) => {
        const isNavigatingToNewPage = item.linkType === LinkType.ItemWithOnlyLink;
        if (isNavigatingToNewPage) {
            deselectSubItems(-1);
        } else {
            deselectSubItems((depthIndex));
        }
    };

    const getIsSelectedItem = (item: NavigationItemModel, depthIndex: number): boolean => {
        return item === selectedItems.get(depthIndex);
    };

    const getHasSubItems = (item: NavigationItemModel): boolean => {
        return item.items && item.items.length > 0;
    };

    const getMaybeNavigableComponentNameFromItem = (item: NavigationItemModel): 'button' | 'router-link-conditional' => {
        return getHasSubItems(item) ? 'button' : 'router-link-conditional';
    };

    const getSelectedItemByIndex = (index: number) => {
        return selectedItems.get(index);
    };

    return {
        deselectSubItems,
        toggleSelectedItem,
        getIsSelectedItem,
        getHasSubItems,
        getMaybeNavigableComponentNameFromItem,
        getSelectedItemByIndex,
    };
}
